import { type FC } from "react";

import { TabItem, Tabs } from "@ui/components/Tabs";

import { type StockStatusElements } from "@jti/fe-common";

import { type FlavorFamilyFilter, type SingleFlavorSelectorItem } from "../../SingleFlavorSelector.types";
import { FlavorListItem } from "../FlavorListItem";

import styles from "../../SingleFlavorSelector.module.scss";

export type FlavorListProps = {
  items: SingleFlavorSelectorItem[];
  flavorFamilyFilters: FlavorFamilyFilter[];
  stockStatusElements: StockStatusElements;
  isProductDataLoading: boolean;
  isActiveCheck: (sku: string) => boolean;
  onItemClick: (item: SingleFlavorSelectorItem) => void;
};

export const FlavorList: FC<FlavorListProps> = ({
  items,
  flavorFamilyFilters,
  stockStatusElements,
  isProductDataLoading,
  isActiveCheck,
  onItemClick,
}) => {
  const renderItems = (flavorItems: SingleFlavorSelectorItem[]) =>
    flavorItems.map((item) => (
      <FlavorListItem
        key={item.sku}
        item={item}
        stockStatus={stockStatusElements[item.sku]}
        isActive={isActiveCheck(item.sku)}
        isProductDataLoading={isProductDataLoading}
        onClick={onItemClick}
      />
    ));

  if (flavorFamilyFilters.length > 0) {
    const activeTabIndex = flavorFamilyFilters.findIndex(({ name }) =>
      items.some(({ sku, flavorFamily }) => flavorFamily?.includes(name) && isActiveCheck(sku))
    );

    return (
      <Tabs tabMenuClassName={styles.tabMenu} defaultTabIndex={activeTabIndex >= 0 ? activeTabIndex : 0}>
        {flavorFamilyFilters.map(({ name, count }) => (
          <TabItem key={name} label={`${name} (${count})`}>
            <ul className={styles.sticksList}>
              {renderItems(items.filter(({ flavorFamily }) => flavorFamily?.includes(name)))}
            </ul>
          </TabItem>
        ))}
      </Tabs>
    );
  }

  return <ul className={styles.sticksList}>{renderItems(items)}</ul>;
};
